<template>
  <div id="app">
    <!-- <div v-if="menuKey == 1" class="floatWindow">
    {{ $store.state.common.appName }}（黄金交易所AA类行员）欢迎您！您现在访问的是香港网站。投资需谨慎。
      <img @click="closer" src="../static/index/closer.png" alt="">
    </div> -->
    <!-- <layout-vue v-if="this.control == false" @getKey="getKey"></layout-vue> -->
    
    <router-view @controlShow="controlShow" />
    <!-- <contactusVue v-if="this.control == false"></contactusVue> -->
  </div>
</template>

<script>
import eventBusMitter from '@/utils/eventbus'
import { mapState, mapActions } from 'vuex';
import { appCode } from '../api/info';
import { get } from 'jquery';

export default {
  name: 'App',
 
  data() {
    return {
      menuKey: null,
      control: false,
      menuKeys:true
    }
  },
  created() {
   
    const channel = appCode()['v'] || appCode()['channel'] || 'N9999';
    sessionStorage.setItem('channel', channel)
    // 接收eventBus传来的值
    eventBusMitter.on('eventBus', (res) => {
      this.control = res.key
    })
    const Rhref = window.location.host;
    if(Rhref.indexOf('rlchltd')>-1){
      this.getAndroidDownloadUrl(9946);
      this.gettradeListUrl();

    } else {
      this.getAndroidDownloadUrl(channel);
    }
    // 判断是否是App登录进来
   
    this.getIosDownloadUrl('IOSDownLoadLinkMT5');
    this.getIosDownloadUrl();
    this.getAICustomService();
    // this.getCustomerService();
    // this.getmt4DownloadUrls();
    // this.getmt5DownloadUrls();
    // this.getCustomerService('PmH5LiveUrl');
  },
  computed: {
    ...mapState('common', {
      live800Url: 'live800Url',
      live800UrlUc: 'live800UrlUc',
    })
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
  methods: {
    ...mapActions('common', {
      getAndroidDownloadUrl: 'getAndroidDownloadUrl',
      getIosDownloadUrl: 'getIosDownloadUrl',
      getAICustomService: 'getAICustomService',
      getCustomerService: 'getCustomerService',
      getmt4DownloadUrls: 'getmt4DownloadUrls',
      getmt5DownloadUrls: 'getmt5DownloadUrls',
      gettradeListUrl: 'gettradeListUrl',
    }),
    getKey(key) {
      this.menuKey = key
    },
    controlShow(key) {
      this.control = key
    },
    closer() {
      this.menuKey = !this.menuKey
    },
  },
}
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  
}
ul {
  padding-left: 0;
  margin: 0 auto;
}
ul li {
  padding-left: 0px;
  list-style: none;
}
p {
  margin: 0;
}
a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
.path {
  stroke: #e90013 !important;
}

@media screen and (max-width: 500px) {
  body {
    overflow-x: hidden;
  }
}
</style>
